export default "__VITE_ASSET__b3427709__"